import React from 'react';
import { Edit2 } from 'lucide-react';
import clsx from 'clsx';

interface SectionHeaderProps {
    icon: React.ElementType;
    colorClass: string;
    title: string;
    onEdit?: () => void;
    canEdit: boolean;
    isDark: boolean;
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ icon: Icon, colorClass, title, onEdit, canEdit, isDark }) => (
    <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2"><Icon size={18} className={colorClass} /><h3 className={clsx('font-semibold', isDark ? 'text-white' : 'text-slate-800')}>{title}</h3></div>
        {canEdit && onEdit && (
            <button onClick={onEdit} className="p-1 hover:bg-slate-700 rounded" title={`Edit ${title}`}><Edit2 size={16} className="text-slate-400" /></button>
        )}
    </div>
);
